import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const Tooltip = styled.div`
  display: none;
  position: absolute;
  left: 0px;
  bottom: -17px;
  position: absolute;
  background-color: rgba(34, 36, 36, 0.9);
  color: ${colors.WHITE};
  font-size: 12px;
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;

  @media (min-width: 769px) {
    bottom: 40px;
  }
`;

export const MadeInButtonContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  padding-bottom: 15px;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};

  @media (min-width: 769px) {
    padding: initial;
    border: initial;
  }

  &:hover {
    ${Tooltip} {
      display: block;
    }
  }
`;

export const CheckWrap = styled.div`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid ${colors.GREY};
  padding: 5px;
  margin-right: 10px;
  transition: all 0.3s;

  .icon {
    width: 24px;
    height: 24px;
    stroke: ${colors.GREY};
  }
`;

export const MadeText = styled.div`
  text-transform: uppercase;
  font-family: ${fonts.latoBold};
  font-size: 12px;
  transition: all 0.3s;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${fonts.latoRegular};
  font-size: 12px;
`;

export const CountText = styled.div`
  font-family: ${fonts.latoBold};
  ${({ madeHover }) => madeHover && `color: ${colors.BLUE_LINK};`}
  ${({ undoHover }) => undoHover && `color: ${colors.RED};`}
`;

export const TextWrap = styled.div``;

export const MadeItContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.hover {
    ${CheckWrap} {
      background: ${colors.BLUE_LINK};
      border: 1px solid ${colors.BLUE_LINK};
      cursor: pointer;

      .icon {
        stroke: ${colors.WHITE};
      }
    }

    ${MadeText} {
      color: ${colors.BLUE_LINK};
    }
  }
`;

export const UndoWrap = styled.div`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid ${colors.GREY};
  padding: 6px 7px;
  margin-left: auto;
  transition: all 0.3s;

  @media (min-width: 769px) {
    margin-left: 10px;
  }

  .icon {
    width: 18px;
    height: 18px;
    stroke: ${colors.GREY};
  }

  &.hover {
    border: 1px solid ${colors.RED};
    cursor: pointer;
    .icon {
      stroke: ${colors.RED};
    }
  }
`;
